export const EmployeeRefTypes = {
    1: 'REF_ECOM',
    2: 'REF_POS',
    3: 'REF_POS_CASHIER',
    4: 'REF_ECOM_PAY_BY_LINK',
    5: 'REF_T_POS',
}